export default () => {
  const domain = window.location.hostname;
  const subdomain = domain.split(".")[0];

  return ["provocator", "provocateur"].includes(subdomain) ? null : subdomain;
};
